import { toRGBA } from '../utils';

const bart = [255, 199, 71];
const b = (opacity: number = 1) => toRGBA(bart[0], bart[1], bart[2], opacity);

export default b;
